export default __webpack_public_path__ + "static/media/noescape.b92b7c3a.png";